(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-again-bar"] && !Shopify.designMode) return;
  try {
    (function () {
      const bar = document.querySelector('[data-buybar]');
      if (!bar || bar.dataset.ready) return;
      bar.dataset.ready = 'true';

      const KEY = 'pawkit:buybar-hidden';
      const restore = document.querySelector('[data-buybar-restore]');
      const SNOOZE_KEY = 'pawkit:buybar-snooze';

      const collapse = (persist) => {
        bar.setAttribute('data-collapsed', 'true');
        bar.classList.add('collapsed');
        if (restore) restore.hidden = false;
        if (persist) {
          try {
            window.localStorage.setItem(KEY, '1');
          } catch (err) {
            /* storage unavailable; session-only collapse */
          }
        }
      };

      const expand = () => {
        bar.setAttribute('data-collapsed', 'false');
        bar.classList.remove('collapsed');
        if (restore) restore.hidden = true;
      };

      // Remembered position: a collapsed bar stays collapsed across pages.
      try {
        if (window.localStorage.getItem(KEY) === '1') collapse(false);
        const snoozedUntil = Number(window.localStorage.getItem(SNOOZE_KEY) || 0);
        if (snoozedUntil && Date.now() < snoozedUntil) collapse(false);
      } catch (err) {
        /* storage unavailable */
      }

      bar.querySelectorAll('[data-buybar-hide]').forEach((btn) =>
        btn.addEventListener('click', () => collapse(true))
      );

      if (restore) restore.addEventListener('click', expand);

      // "Not yet" pushes the date; it does not dismiss a nag.
      bar.querySelectorAll('[data-buybar-snooze]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const until = Date.now() + 7 * 24 * 60 * 60 * 1000;
          try {
            window.localStorage.setItem(SNOOZE_KEY, String(until));
          } catch (err) {
            /* storage unavailable */
          }
          collapse(true);
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.ready) return;
    drawer.dataset.ready = 'true';

    const open = () => {
      drawer.setAttribute('data-open', '');
      document.body.classList.add('overflow-hidden');
    };
    const close = () => {
      drawer.removeAttribute('data-open');
      document.body.classList.remove('overflow-hidden');
    };

    document.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (btn.hasAttribute('onclick')) return;
        e.preventDefault();
        open();
      });
    });

    drawer.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('data-open')) close();
    });

    const update = async (body) => {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) return;
      const cart = await res.json();
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
      const section = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
      if (section.ok) {
        const html = await section.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-body]');
        const current = drawer.querySelector('[data-cart-body]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        const freshSub = doc.querySelector('[data-cart-subtotal]');
        const curSub = drawer.querySelector('[data-cart-subtotal]');
        if (freshSub && curSub) curSub.textContent = freshSub.textContent;
      }
    };

    drawer.addEventListener('click', (e) => {
      const change = e.target.closest('[data-qty-change]');
      if (change) {
        const index = parseInt(change.dataset.qtyChange, 10) + 1;
        const delta = parseInt(change.dataset.qtyDelta, 10);
        const input = drawer.querySelector(`[data-qty-input="${index - 1}"]`);
        const current = input ? parseInt(input.value, 10) : 1;
        const next = Math.max(0, current + delta);
        update({ line: index, quantity: next });
        return;
      }

      const remove = e.target.closest('[data-qty-remove]');
      if (remove) {
        const index = parseInt(remove.dataset.qtyRemove, 10) + 1;
        update({ line: index, quantity: 0 });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-mobile-nav-close]').forEach((el) => {
      el.addEventListener('click', () => {
        const nav = document.getElementById('MobileNav');
        if (!nav) return;
        nav.removeAttribute('data-open');
        document.body.classList.remove('overflow-hidden');
        const toggle = document.querySelector('[data-mobile-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('product-form')) return;

    customElements.define(
      'product-form',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready) return;
          this.dataset.ready = 'true';

          this.form = this.querySelector('form');
          this.button = this.querySelector('[data-add-button]');
          this.buttonText = this.querySelector('[data-add-text]');
          if (!this.form || !this.button) return;

          this.defaultText = this.buttonText ? this.buttonText.textContent.trim() : '';
          this.addingText = this.getAttribute('data-adding') || this.defaultText;

          this.setupQuantity();

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.submit();
          });

          this.addEventListener('variant:changed', (event) => this.onVariantChange(event.detail.variant));
        }

        setupQuantity() {
          const field = this.querySelector('[data-qty-field]');
          if (!field) return;

          this.querySelectorAll('[data-qty-step]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const step = Number(btn.dataset.qtyStep);
              const min = Number(field.min) || 1;
              const next = Math.max(min, (Number(field.value) || min) + step);
              field.value = next;
            });
          });
        }

        onVariantChange(variant) {
          if (!variant) return;

          const idInput = this.form.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = variant.id;
            idInput.disabled = !variant.available;
          }

          if (this.button) {
            this.button.disabled = !variant.available;
            if (this.buttonText) {
              this.buttonText.textContent = variant.available
                ? this.defaultText
                : this.getAttribute('data-sold-out') || this.defaultText;
            }
          }

          const dynamic = this.querySelector('[data-dynamic-checkout]');
          if (dynamic) dynamic.hidden = !variant.available;

          const priceTarget = document.querySelector('[data-product-price]');
          if (priceTarget && variant.price != null) {
            priceTarget.dispatchEvent(
              new CustomEvent('price:changed', { detail: { variant }, bubbles: true })
            );
          }
        }

        async submit() {
          const original = this.buttonText ? this.buttonText.textContent : '';
          this.button.disabled = true;
          if (this.buttonText) this.buttonText.textContent = this.addingText;
          const spinner = this.querySelector('[data-add-spinner]');
          if (spinner) spinner.hidden = false;

          try {
            const body = new FormData(this.form);
            body.append('sections', 'cart-drawer,cart-icon-bubble');
            body.append('sections_url', window.location.pathname);

            const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body,
            });

            if (!res.ok) {
              const error = await res.json().catch(() => ({}));
              throw new Error(error.description || 'Could not add to cart');
            }

            const cart = await res.json();
            const drawer = document.querySelector('[data-cart-drawer]');
            if (drawer) {
              document.querySelectorAll('[data-cart-count]').forEach((el) => {
                if (cart.item_count != null) {
                  el.textContent = cart.item_count;
                  el.classList.toggle('is-empty', cart.item_count === 0);
                }
              });
              drawer.setAttribute('data-open', '');
              document.body.classList.add('overflow-hidden');
              const sectionRes = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
              if (sectionRes.ok) {
                const html = await sectionRes.text();
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const fresh = doc.querySelector('[data-cart-body]');
                const current = drawer.querySelector('[data-cart-body]');
                if (fresh && current) current.innerHTML = fresh.innerHTML;
              }
            } else {
              window.location.href = `${window.Shopify.routes.root}cart`;
            }
          } catch (err) {
            const errorEl = this.querySelector('[data-form-error]');
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          } finally {
            this.button.disabled = false;
            if (this.buttonText) this.buttonText.textContent = original;
            if (spinner) spinner.hidden = true;
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('media-gallery')) return;

    customElements.define(
      'media-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready) return;
          this.dataset.ready = 'true';

          this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
          if (this.slides.length < 2) return;

          this.index = 0;

          this.querySelectorAll('[data-gallery-prev]').forEach((btn) =>
            btn.addEventListener('click', () => this.go(this.index - 1))
          );
          this.querySelectorAll('[data-gallery-next]').forEach((btn) =>
            btn.addEventListener('click', () => this.go(this.index + 1))
          );
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryThumb)))
          );

          this.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.go(this.index - 1);
            if (event.key === 'ArrowRight') this.go(this.index + 1);
          });
        }

        go(next) {
          if (this.slides.length === 0) return;
          this.index = (next + this.slides.length) % this.slides.length;

          this.slides.forEach((slide, i) => {
            const active = i === this.index;
            slide.classList.toggle('is-active', active);
            slide.hidden = !active;
          });

          this.thumbs.forEach((thumb, i) => {
            const active = i === this.index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-selected', String(active));
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
      if (customElements.get('variant-picker')) return;

      customElements.define(
        'variant-picker',
        class extends HTMLElement {
          connectedCallback() {
            if (this.dataset.ready) return;
            this.dataset.ready = 'true';

            this.radios = Array.from(this.querySelectorAll('[data-option-input]'));
            this.selects = Array.from(this.querySelectorAll('[data-option-select]'));
            this.jsonEl = this.querySelector('[data-variant-json]');
            this.variants = this.jsonEl ? JSON.parse(this.jsonEl.textContent) : [];
            this.form = this.closest('product-form') || document.querySelector('product-form');
            this.pickerCount = Number(this.querySelectorAll('[data-option-index]').length);

            this.addEventListener('change', () => this.onChange());
          }

          selectedOptions() {
            const options = [];
            for (let i = 0; i < this.pickerCount; i += 1) {
              const radio = this.querySelector(`[data-option-input="${i}"]:checked`);
              if (radio) {
                options.push(radio.value);
                continue;
              }
              const select = this.querySelector(`[data-option-select="${i}"]`);
              options.push(select ? select.value : '');
            }
            return options;
          }

          onChange() {
            const options = this.selectedOptions();

            this.querySelectorAll('[data-option-index]').forEach((group, index) => {
              const target = group.querySelector('[data-selected-value]');
              if (target) target.textContent = options[index];
            });

            const match = this.variants.find(
              (variant) =>
                variant.options.length === options.length &&
                variant.options.every((value, index) => value === options[index])
            );

            this.updateForm(match);
            this.updateAvailability(options);
          }

          updateForm(variant) {
            if (!this.form || !variant) return;
            const idInput = this.form.querySelector('input[name="id"]');
            if (idInput) {
              idInput.value = variant.id;
              idInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());

            this.dispatchEvent(
              new CustomEvent('variant:changed', { detail: { variant }, bubbles: true })
            );
          }

          updateAvailability(options) {
            this.querySelectorAll('[data-option-input]').forEach((input) => {
              const index = Number(input.dataset.optionInput);
              const candidate = options.slice();
              candidate[index] = input.value;

              const exists = this.variants.some(
                (variant) =>
                  variant.options.length === candidate.length &&
                  variant.options.every((value, i) => value === candidate[i])
              );

              const label = this.querySelector(`label[for="${input.id}"]`);
              if (label) label.classList.toggle('is-unavailable', !exists);
              input.disabled = !exists && !input.checked;
            });
          }
        }
      );
    })();
  } catch(e) { console.error(e); }
})();

})();
